import type {
  CodePurpose,
  CodeSent,
  IdentifyResult,
  OpenedSession,
  PasscodeChannel,
} from '../types/domain.types';

import { PASSCODE_ENDPOINTS } from './endpoints';
import { request } from './http';
import { readOpenedSession } from './openedSession';
import { codeSentSchema, identifyResultSchema, parseOrThrow } from './schemas';

export interface CodeRequest {
  readonly identifier: string;
  readonly channel?: PasscodeChannel;
  readonly purpose?: CodePurpose;
}

const codeRequestBody = ({ identifier, channel, purpose }: CodeRequest) => ({
  identifier,
  ...(channel === undefined ? {} : { channel }),
  ...(purpose === undefined ? {} : { purpose }),
});

export const identify = async (identifier: string, signal: AbortSignal | undefined): Promise<IdentifyResult> => {
  const raw = await request('post', PASSCODE_ENDPOINTS.IDENTIFY, { body: { identifier }, signal });
  return parseOrThrow(identifyResultSchema, raw, 'identify');
};

export const sendCode = async (input: CodeRequest, signal: AbortSignal | undefined): Promise<CodeSent> => {
  const raw = await request('post', PASSCODE_ENDPOINTS.CODE, { body: codeRequestBody(input), signal });
  return parseOrThrow(codeSentSchema, raw, 'code');
};

export const verifyCode = async (
  input: { readonly identifier: string; readonly code: string },
  signal: AbortSignal | undefined,
): Promise<OpenedSession> => {
  const raw = await request('post', PASSCODE_ENDPOINTS.VERIFY, { body: { identifier: input.identifier, code: input.code }, signal });
  return readOpenedSession(raw, 'verify');
};
